import { render } from "./CouponItem.vue?vue&type=template&id=5a9d9c2a&scoped=true"
import script from "./CouponItem.vue?vue&type=script&lang=js"
export * from "./CouponItem.vue?vue&type=script&lang=js"

import "./CouponItem.vue?vue&type=style&index=0&id=5a9d9c2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9d9c2a"]])

export default __exports__